module.exports = __webpack_public_path__ + "img/pic_tx_zf.de2edab8.png";